export enum RequestType {
    BASIC = 'BASIC',
    ANONYMOUS = 'ANONYMOUS',
    CORPORATE = 'CORPORATE'
}
